const cdn = import.meta.env.DEV ? '' : (import.meta.env.VITE_CDN || '').replace(/\/$/, '')

export function prefixCDN<T>(obj: T): T {
  if (typeof obj === 'string')
    return (obj.startsWith('/') ? cdn + obj : obj) as T
  if (typeof obj === 'object' && obj !== null) {
    const result = {} as T
    for (const key in obj)
      (result as any)[key] = prefixCDN((obj as any)[key])
    return result
  }
  return obj
}
